<template lang="pug">
div
  template(v-if="edit")
    MediumForm(@save="closeEditor")

  template(v-else="")
    LoaderOverlay(:loading="loading")
      figure(v-if="isImage")
        a(href="#" data-toggle="modal" data-target="#medium-expanded-modal")
          ImageLoader(imgClass="img-responsive" :src="url")
          i.expand.fa.fa-expand.fa-2x

      dl
        dt Filename
        dd.filename {{ url | mediaFileName }}

        dt Folder
        dd.filepath {{ url | filePath }}

        dt Status
        dd {{ squeueTitle }}

        dt Print Section
        dd {{ sectionTitle }}

        dt Cutline
        dd {{ cutline }}

        dt Credit
        dd {{ credit }}

        dt Created
        dd
          DateValue(:value="createdAt")

        dt(v-if="stories.length > 0") Stories
        template(v-for="story in stories")
          dd
            a(:href="story.url")
              i.fa.fa-newspaper-o
              |
              | {{ story.slug }}

      .buttons.text-right
        a.btn.btn-default(:href="downloadUrl")
          i.fa.fa-cloud-download
          |
          | Download
        |
        |
        button.btn.btn-default(type="button" @click="edit = true")
          i.fa.fa-pencil
          |
          | Edit
        |
        |
        button.btn.btn-danger(type="button" @click="destroy()")
          i.fa.fa-trash

    #medium-expanded-modal.modal.fade(tabindex="-1" v-if="isImage")
      .modal-dialog.modal-lg
        .modal-content
          img.img-responsive.img-thumbnail(:src="url" style="min-width: 100%")
</template>

<script>
  import { mapGetters } from 'vuex'
  import { sync } from 'vuex-pathify'

  import DateValue from '../../../components/shared/date_value.vue'
  import ImageLoader from '../../../components/shared/image_loader.vue'
  import LoaderOverlay from '../../../components/shared/loader_overlay.vue'
  import MediumForm from './form.vue'

  export default {
    components: {
      DateValue,
      ImageLoader,
      LoaderOverlay,
      MediumForm
    },

    data() {
      return {
        edit: false,
        loading: false
      }
    },

    computed: {
      ...mapGetters('medium', [
        'isImage'
      ]),
      ...sync('medium', [
        'id',
        'url',
        'cutline',
        'credit',
        'contentType',
        'filename',
        'relative_path',
        'squeueTitle',
        'sectionTitle',
        'createdAt',
        'stories'
      ]),

      downloadUrl() { return `/media/${this.id}` }
    },

    methods: {
      closeEditor() {
        this.edit = false
      },

      destroy() {
        if (confirm(`Sure you want to delete ${this.filename}?`)) {
          this.loading = true

          this.$store.dispatch('medium/destroy', { id: this.id }).then(() => {
            this.closeEditor()
            this.loading = false
          })
        }
      }
    }
  }
</script>
